export interface ResourceSkill {
  id: number;
  name: string;
  color: string;
}

export interface ResourceCategoryDef {
  id: number;
  name: string;
  color: string;
  countsAsAbsence: boolean;
  sortOrder: number;
}

export interface PlannableUser {
  id: string;
  name: string;
  email: string;
  isPlannable: boolean;
  weeklyCapacityHours: number;
  skills: ResourceSkill[];
  hasCalendarFeed?: boolean;
  calendarFeedUrl?: string | null;
}

export interface ExternalCalendarEvent {
  userId: string;
  userName?: string;
  uid: string;
  title: string;
  start: string;
  end: string;
  allDay: boolean;
  hidden?: boolean;
}

export interface ResourceAssignment {
  id: number;
  assignedUserId: string;
  assignedUserName?: string;
  assignedUserEmail?: string;
  participantUserIds?: string[];
  participantNames?: string[];
  title: string;
  categoryId?: number | null;
  categoryName?: string;
  categoryColor?: string;
  categoryIsAbsence?: boolean;
  start: string;   // ISO (lokale Wandzeit)
  end: string;     // ISO (lokale Wandzeit)
  location?: string;
  customerId?: number | null;
  customerName?: string;
  equipmentId?: number | null;
  equipmentName?: string;
  maintenanceId?: number | null;
  maintenanceTitle?: string;
  notes?: string;
  color?: string;
  sourceExternalUid?: string | null;
  seriesId?: string | null;
  travelMinutesBefore?: number;
  travelMinutesAfter?: number;
  approvalStatus?: string;
  workStatus?: string;
  status: string;
  inviteSent: boolean;
  inviteSentAtUtc?: string | null;
}

export interface ResourceAssignmentPayload {
  assignedUserId: string;
  participantUserIds?: string[];
  title: string;
  categoryId?: number | null;
  start: string;
  end: string;
  location?: string;
  customerId?: number | null;
  equipmentId?: number | null;
  maintenanceId?: number | null;
  notes?: string;
  color?: string;
  sourceExternalUid?: string | null;
  travelMinutesBefore?: number;
  travelMinutesAfter?: number;
  workStatus?: string;
  sendInvite: boolean;
  repeatMode?: string;
  repeatCount?: number;
}

export interface MyAbsence {
  id: number;
  title: string;
  categoryId?: number | null;
  categoryName?: string;
  categoryColor?: string;
  start: string;
  end: string;
  notes?: string;
  approvalStatus: string;
}

export interface MyAbsencePayload {
  categoryId?: number | null;
  title?: string;
  start: string;
  end: string;
  notes?: string;
}

export interface PlanningProfilePayload {
  isPlannable: boolean;
  weeklyCapacityHours: number;
  skillIds: number[];
  calendarFeedUrl?: string | null;
}

export function assignmentColor(a: ResourceAssignment): string {
  return a.color || a.categoryColor || '#1976d2';
}

export type ResourceWorkStatus = 'Planned' | 'Confirmed' | 'EnRoute' | 'Done';

export const WORK_STATUSES: { value: ResourceWorkStatus; label: string; color: string; icon: string }[] = [
  { value: 'Planned', label: 'Geplant', color: '#90a4ae', icon: 'schedule' },
  { value: 'Confirmed', label: 'Bestätigt', color: '#1976d2', icon: 'check_circle' },
  { value: 'EnRoute', label: 'Unterwegs', color: '#f57c00', icon: 'directions_car' },
  { value: 'Done', label: 'Erledigt', color: '#2e7d32', icon: 'done_all' }
];

export function workStatusMeta(status?: string): { value: ResourceWorkStatus; label: string; color: string; icon: string } {
  return WORK_STATUSES.find(w => w.value === status) || WORK_STATUSES[0];
}

// Farbpalette + stabiler Hash für "Einfärben nach Kunde".
const PALETTE = ['#1976d2', '#388e3c', '#f57c00', '#7b1fa2', '#c2185b', '#00838f', '#5d4037', '#455a64', '#e64a19', '#0288d1'];
export function paletteColor(key: string | null | undefined): string {
  const s = key || 'ohne';
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) & 0x7fffffff;
  }
  return PALETTE[h % PALETTE.length];
}
